import * as React from 'react';
import { INotificationInfo } from './notification-types';
import { useNotificationEvents } from './notification-event-context';

export const NotificationCreator = React.memo((props: INotificationInfo) => {
    const { showNotifications } = useNotificationEvents();
    React.useEffect(() => {
        showNotifications({ ...props });
    }, [props, showNotifications]);
    return null;
});

NotificationCreator.displayName = 'NotificationCreator';

type IFlavouredNotificationInfo = Omit<INotificationInfo, 'type'>;
export function ErrorNotificationCreator(props: IFlavouredNotificationInfo) {
    return <NotificationCreator {...props} type="error" />;
}

export function InformationNotificationCreator(props: IFlavouredNotificationInfo) {
    return <NotificationCreator {...props} type="information" />;
}

export function SuccessNotificationCreator(props: IFlavouredNotificationInfo) {
    return <NotificationCreator {...props} type="success" />;
}

export function WarningNotificationCreator(props: IFlavouredNotificationInfo) {
    return <NotificationCreator {...props} type="warning" />;
}
